function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  className: "cls-1",
  d: "M102.52 141l-.74.43a1 1 0 00-.31 1.48c3.75 5 15.52 28.93 19 36.07a2.4 2.4 0 01-1 3.14l-17.6 10.18a2.41 2.41 0 01-2.84-.31c-2.49-2.3-8.3-7.8-15.37-15.5-9.49-10.32-20.91-30.07-24.92-40s-4-10-5.95-19.4c-4.48 5.71-3.15 19.09-2.79 22.06a2.17 2.17 0 00.42 1.05c1.48 2 7.26 9.65 8.58 11.94 1.52 2.63 0 4.7-1.11 4.16A86.32 86.32 0 0150 151a1.52 1.52 0 00-1.43-.22c-1.78.7 1.08 3.23 1.08 3.23a47.17 47.17 0 005.68 3.74 3.72 3.72 0 012.05 2.61 2.31 2.31 0 01-.68 2.32c-3.69 3.32-9.35 1.69-12.48.38a8.71 8.71 0 01-4-3.3 19 19 0 01-3.09-9.08 18.73 18.73 0 00-2.7-10.74c-14.13-27.08 3.31-51.12 4.86-55.66 9-3.18 15.13-10.62 22.07-14.56l-.21.12C68.07 65.77 76.72 63.65 84 57.4c4.71.93 35.09-1.66 51.52 24.1a18.73 18.73 0 008 7.69 19 19 0 016.33 7.21 8.71 8.71 0 01.89 5.07c-.43 3.36-1.84 9.08-6.55 10.62a2.31 2.31 0 01-2.35-.57 3.72 3.72 0 01-1.24-3.08 47.17 47.17 0 00-.41-6.79s-.76-3.72-2.25-2.55a1.52 1.52 0 00-.53 1.35c.36 3.46 1.8 8.8.56 9.51s-2.63 1.52-4.16-1.11c-1.32-2.29-5.11-11.13-6.07-13.39a2.17 2.17 0 00-.7-.89c-2.39-1.79-13.33-9.62-20.51-8.58 7.2 6.37 7.2 6.38 13.85 14.83s18.07 28.2 22.29 41.57c3.15 10 5 17.75 5.78 21.05a2.41 2.41 0 01-1.14 2.62l-17.6 10.18a2.4 2.4 0 01-3.2-.73c-4.45-6.58-19.32-28.71-21.79-34.46a1 1 0 00-1.43-.47l-.74.43"
})), React.createElement("clipPath", {
  id: "clip-path-2"
}, React.createElement("circle", {
  className: "cls-2",
  cx: 60.18,
  cy: 93.32,
  r: 6.99,
  transform: "rotate(-30.05 60.18 93.32)"
})), React.createElement("clipPath", {
  id: "clip-path-3"
}, React.createElement("path", {
  className: "cls-3",
  d: "M129.12 178.73l10.53 16.4a11.24 11.24 0 008.07 4.42 15.15 15.15 0 004.35-.21 18 18 0 005.6-2.12c9.16-5.25 17.65-10.09 8.59-17.5a15 15 0 00-5.65-2.87c-.87-.23-1.73-.43-2.51-.61a10 10 0 01-6.6-4.91l-2.11-3.75z"
})), React.createElement("clipPath", {
  id: "clip-path-4"
}, React.createElement("path", {
  className: "cls-3",
  d: "M122.22 182.72l9 17.31a11.24 11.24 0 01-.19 9.2 15.15 15.15 0 01-2.36 3.67 18 18 0 01-4.63 3.8c-9.12 5.33-17.55 10.27-19.45-1.27a15 15 0 01.33-6.33c.24-.87.48-1.71.73-2.48a10 10 0 00-1-8.17l-2.2-3.69z"
})), React.createElement("clipPath", {
  id: "clip-path-5"
}, React.createElement("path", {
  id: "ear",
  className: "cls-4",
  d: "M11.68 50.55v18.26a7.3 7.3 0 01-7.3-7.3v-3.65a7.3 7.3 0 017.3-7.3z",
  transform: "rotate(-29.9 8.12 59.79)"
})), React.createElement("clipPath", {
  id: "clip-path-6"
}, React.createElement("path", {
  id: "ear-2",
  "data-name": "ear",
  className: "cls-4",
  d: "M82.77 9.43v18.26a7.3 7.3 0 01-7.3-7.3v-3.66a7.3 7.3 0 017.3-7.3z",
  transform: "rotate(149.95 79.11 18.56)"
})), React.createElement("clipPath", {
  id: "clip-path-7"
}, React.createElement("circle", {
  id: "_Ellipse_",
  "data-name": "<Ellipse>",
  className: "cls-5",
  cx: 43.68,
  cy: 39.58,
  r: 38.78,
  transform: "rotate(-29.9 43.81 39.6)"
})), React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -49.41,
  y1: 199.04,
  x2: -35.42,
  y2: 199.04,
  gradientTransform: "translate(102.6 -105.72)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#9e23cc"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4619bf"
})), React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -48.06,
  y1: 218.81,
  x2: -16.1,
  y2: 218.81,
  gradientTransform: "translate(113.84 -113.31)",
  xlinkHref: "#linear-gradient"
}), React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -51.67,
  y1: 143.38,
  x2: -1.64,
  y2: 143.38,
  gradientTransform: "rotate(-30.05 -188.05 -44.96)",
  xlinkHref: "#linear-gradient"
}), React.createElement("style", null, "\r\n      .cls-1{fill:#f2f2f2}.cls-2{fill:url(#linear-gradient)}.cls-12,.cls-3{fill:#dedfe0}.cls-4{fill:#c6c6c6}.cls-5{fill:#e8e8e8}.cls-7{fill:#b5b5b5}.cls-8{fill:#969696}.cls-10{fill:#ffcb39}.cls-11{fill:#fff;mix-blend-mode:soft-light}.cls-12{mix-blend-mode:multiply}.cls-15{fill:#d3d3d3}.cls-19{fill:#c4c4c4}.cls-20{fill:#adadad}.cls-23{fill:#b2b2b2}.cls-29{fill:#d8d8d8}\r\n    "));

var _ref3 = React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  className: "cls-7",
  x: 25.87,
  y: 78.21,
  width: 6.32,
  height: 6.32,
  rx: 3.16,
  ry: 3.16,
  transform: "rotate(149.95 29.03 81.37)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M91.91 123.18L61.16 141a10.6 10.6 0 01-13.91-3l-24.38-33.9a15.5 15.5 0 014.82-22.46L57.8 64.2z"
}), React.createElement("path", {
  className: "cls-7",
  d: "M91.69 122.79l-29.6 17.12a10.2 10.2 0 01-13.4-2.91l-23.28-32.34a15.21 15.21 0 014.73-22L58.84 66z"
}), React.createElement("rect", {
  className: "cls-7",
  x: 84.16,
  y: 44.49,
  width: 6.32,
  height: 6.32,
  rx: 3.16,
  ry: 3.16,
  transform: "rotate(-30.05 87.32 47.64)"
}), React.createElement("path", {
  className: "cls-8",
  d: "M91.82 123.23l30.75-17.79a10.6 10.6 0 004.35-13.55l-17.23-38a15.5 15.5 0 00-21.87-7L57.71 64.26z"
}), React.createElement("path", {
  className: "cls-7",
  d: "M91.21 123.07l29.6-17.12a10.2 10.2 0 004.19-13l-16.46-36.37a15.21 15.21 0 00-21.47-6.89l-28.7 16.6z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M102.52 141l-.74.43a1 1 0 00-.31 1.48c3.75 5 15.52 28.93 19 36.07a2.4 2.4 0 01-1 3.14l-17.6 10.18a2.41 2.41 0 01-2.84-.31c-2.49-2.3-8.3-7.8-15.37-15.5-9.49-10.32-20.91-30.07-24.92-40s-4-10-5.95-19.4c-4.48 5.71-3.15 19.09-2.79 22.06a2.17 2.17 0 00.42 1.05c1.48 2 7.26 9.65 8.58 11.94 1.52 2.63 0 4.7-1.11 4.16A86.32 86.32 0 0150 151a1.52 1.52 0 00-1.43-.22c-1.78.7 1.08 3.23 1.08 3.23a47.17 47.17 0 005.68 3.74 3.72 3.72 0 012.05 2.61 2.31 2.31 0 01-.68 2.32c-3.69 3.32-9.35 1.69-12.48.38a8.71 8.71 0 01-4-3.3 19 19 0 01-3.09-9.08 18.73 18.73 0 00-2.7-10.74c-14.13-27.08 3.31-51.12 4.86-55.66 9-3.18 15.13-10.62 22.07-14.56l-.21.12C68.07 65.77 76.72 63.65 84 57.4c4.71.93 35.09-1.66 51.52 24.1a18.73 18.73 0 008 7.69 19 19 0 016.33 7.21 8.71 8.71 0 01.89 5.07c-.43 3.36-1.84 9.08-6.55 10.62a2.31 2.31 0 01-2.35-.57 3.72 3.72 0 01-1.24-3.08 47.17 47.17 0 00-.41-6.79s-.76-3.72-2.25-2.55a1.52 1.52 0 00-.53 1.35c.36 3.46 1.8 8.8.56 9.51s-2.63 1.52-4.16-1.11c-1.32-2.29-5.11-11.13-6.07-13.39a2.17 2.17 0 00-.7-.89c-2.39-1.79-13.33-9.62-20.51-8.58 7.2 6.37 7.2 6.38 13.85 14.83s18.07 28.2 22.29 41.57c3.15 10 5 17.75 5.78 21.05a2.41 2.41 0 01-1.14 2.62l-17.6 10.18a2.4 2.4 0 01-3.2-.73c-4.45-6.58-19.32-28.71-21.79-34.46a1 1 0 00-1.43-.47l-.74.43"
}), React.createElement("g", {
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  className: "cls-10",
  transform: "rotate(-66.7 112.1 64.02)",
  d: "M102.92 60.31h18.38v7.44h-18.38z"
}), React.createElement("path", {
  className: "cls-11",
  d: "M84 57.4s33.5 5.64 47.74 20.34c11.5 16.28 9.9 9.91 11.65 12s9 4.71 4.3 19.15 12.71-8.66 12.71-8.66l-23.67-36.34-49.81-11.32-2.39 4z"
}), React.createElement("path", {
  className: "cls-10",
  transform: "rotate(4.17 28.7 112.41)",
  d: "M19.21 108.48h18.95v7.67H19.21z"
}), React.createElement("path", {
  className: "cls-10",
  transform: "rotate(-37.6 126.08 143.67)",
  d: "M106.09 142.05h40.01v3.26h-40.01z"
}), React.createElement("path", {
  className: "cls-10",
  transform: "rotate(-22.5 91.3 163.71)",
  d: "M71.28 162.08h40.01v3.26H71.28z"
}), React.createElement("path", {
  className: "cls-12",
  d: "M130.51 94.6S116 82.14 99.61 81.72c0 0 22.44 19.86 28.56 34 3.22 6.48 22.61 42.7 20.27 54 11.46-10.8-17.93-75.12-17.93-75.12z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M66.44 152.34s-13.54-34.22-13-45c-6 14.92-8.56 22.15-4.8 34.05 9.18 11.37 15.76 16.43 15.76 16.43z"
}), React.createElement("path", {
  className: "cls-12",
  d: "M101.66 141.53l-3.86 2.23a1.1 1.1 0 00-.35 1.59c3.05 4.32 15.42 22.14 23.57 38.92a1.1 1.1 0 001.86.21 7.9 7.9 0 001.68-5.34 1.09 1.09 0 00-.15-.47l-21.25-36.73a1.1 1.1 0 00-1.5-.41z"
}), React.createElement("path", {
  className: "cls-11",
  d: "M38.6 92.51c-7.44 10.56-7.1 22.87-7.14 25.5a55.92 55.92 0 002.44 16.83c3.39 5.86 4.46 10.41 4 11.47s-6 5.84-6 5.84l-15.59-27 1.65-26 20.71-15.54z"
})), React.createElement("circle", {
  className: "cls-2",
  cx: 60.18,
  cy: 93.32,
  r: 6.99,
  transform: "rotate(-30.05 60.18 93.32)"
}), React.createElement("g", {
  clipPath: "url(#clip-path-2)"
}, React.createElement("path", {
  d: "M63.92 88.92l-3.25 1.88.27-6.48-3.79 2.19.56 9.16 2.8-1.62 1 8.25z",
  fill: "#5208bc"
})), React.createElement("path", {
  className: "cls-10",
  d: "M63.3 88.76l-3.25 1.88.27-6.48-3.79 2.19.56 9.16 2.8-1.62 1 8.25z"
}), React.createElement("path", {
  className: "cls-15",
  d: "M103.94 113.17l-26.15 15.46a6 6 0 01-8.27-2.12L63.28 116a6 6 0 012.12-8.27l26.16-15.51a6 6 0 018.27 2.12l6.24 10.55a6 6 0 01-2.13 8.28z"
}), React.createElement("rect", {
  className: "cls-7",
  x: 70.63,
  y: 115.12,
  width: 12.88,
  height: 2.39,
  rx: 1.19,
  ry: 1.19,
  transform: "rotate(-30.6 77.06 116.3)"
}), React.createElement("circle", {
  className: "cls-10",
  cx: 80.97,
  cy: 114,
  r: 0.95,
  transform: "rotate(-30.6 80.95 113.98)"
}), React.createElement("rect", {
  className: "cls-7",
  x: 72.33,
  y: 117.99,
  width: 12.88,
  height: 2.39,
  rx: 1.19,
  ry: 1.19,
  transform: "rotate(-30.6 78.74 119.18)"
}), React.createElement("circle", {
  className: "cls-10",
  cx: 76.1,
  cy: 120.76,
  r: 0.95,
  transform: "rotate(-30.6 76.1 120.75)"
}), React.createElement("rect", {
  className: "cls-7",
  x: 74.03,
  y: 120.87,
  width: 12.88,
  height: 2.39,
  rx: 1.19,
  ry: 1.19,
  transform: "rotate(-30.6 80.45 122.04)"
}), React.createElement("circle", {
  className: "cls-10",
  cx: 81.91,
  cy: 121.21,
  r: 0.95,
  transform: "rotate(-30.6 81.88 121.2)"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 93.61 105.4)",
  d: "M87.9 105.17h11.45v.48H87.9z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 94 106.06)",
  d: "M88.3 105.84h11.45v.48H88.3z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 94.4 106.74)",
  d: "M88.7 106.52h11.45v.48H88.7z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.7 94.51 107.28)",
  d: "M89.09 107.19h11.45v.48H89.09z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 95.2 108.08)",
  d: "M89.49 107.86h11.45v.48H89.49z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 95.6 108.76)",
  d: "M89.89 108.53h11.45v.48H89.89z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.7 95.69 109.29)",
  d: "M90.29 109.2h11.45v.48H90.29z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.7 96.1 109.95)",
  d: "M90.68 109.88h11.45v.48H90.68z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.7 96.5 110.63)",
  d: "M91.08 110.55h11.45v.48H91.08z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.7 96.88 111.3)",
  d: "M91.48 111.22h11.45v.48H91.48z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 97.59 112.11)",
  d: "M91.88 111.89h11.45v.48H91.88z"
}), React.createElement("path", {
  className: "cls-7",
  transform: "rotate(-30.6 97.98 112.79)",
  d: "M92.27 112.56h11.45v.48H92.27z"
}), React.createElement("rect", {
  x: 65.78,
  y: 102.87,
  width: 31.97,
  height: 5.25,
  rx: 2.62,
  ry: 2.62,
  transform: "rotate(-30.6 81.74 105.48)",
  fill: "url(#linear-gradient-3)"
}), React.createElement("path", {
  className: "cls-15",
  transform: "rotate(-32.96 134.27 92.09)",
  d: "M124.79 90.51h18.95v3.16h-18.95z"
}), React.createElement("path", {
  className: "cls-15",
  transform: "rotate(-25.35 43.87 144)",
  d: "M34.4 142.43h18.95v3.16H34.4z"
}), React.createElement("path", {
  className: "cls-15",
  transform: "rotate(-30.12 97.91 133.28)",
  d: "M60.23 130.11h75.35v6.32H60.23z"
}), React.createElement("rect", {
  className: "cls-7",
  x: 91.39,
  y: 129.1,
  width: 12.63,
  height: 8.57,
  rx: 1.32,
  ry: 1.32,
  transform: "rotate(-30.12 97.72 133.39)"
}), React.createElement("circle", {
  cx: 97.71,
  cy: 133.38,
  r: 2.93,
  transform: "rotate(-30.12 97.72 133.39)",
  fill: "#fcfcfc"
}), React.createElement("path", {
  className: "cls-3",
  d: "M129.12 178.73l10.53 16.4a11.24 11.24 0 008.07 4.42 15.15 15.15 0 004.35-.21 18 18 0 005.6-2.12c9.16-5.25 17.65-10.09 8.59-17.5a15 15 0 00-5.65-2.87c-.87-.23-1.73-.43-2.51-.61a10 10 0 01-6.6-4.91l-2.11-3.75z"
}), React.createElement("g", {
  clipPath: "url(#clip-path-3)"
}, React.createElement("circle", {
  className: "cls-19",
  cx: 158.17,
  cy: 175.3,
  r: 5.64,
  transform: "rotate(-30.05 158.16 175.3)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M130.73 197.69l6.5-5.85a11.24 11.24 0 008.07 4.42 15.15 15.15 0 004.35-.21 18 18 0 005.6-2.12c9.16-5.25 17.65-10.09 8.59-17.5a15 15 0 00-5.65-2.87c-.87-.23-1.73-.43-2.51-.61-2.8-.61 16.27.54 14.86-2l7.11 10.48-3.86 9.57-10 8.9-11.22 4.93-7 .43-6.39-2-4.44-3.17z"
})), React.createElement("rect", {
  className: "cls-15",
  x: 125.42,
  y: 168.94,
  width: 26.62,
  height: 4.96,
  rx: 2.48,
  ry: 2.48,
  transform: "rotate(149.95 138.73 171.43)"
}), React.createElement("path", {
  className: "cls-20",
  transform: "rotate(-30.05 139.68 184.15)",
  d: "M139.14 179.19h1.11v9.93h-1.11z"
}), React.createElement("path", {
  className: "cls-20",
  transform: "rotate(-30.05 144.68 181.26)",
  d: "M144.13 176.31h1.11v9.93h-1.11z"
}), React.createElement("path", {
  className: "cls-20",
  transform: "rotate(-30.05 142.19 182.7)",
  d: "M141.64 177.75h1.11v9.93h-1.11z"
}), React.createElement("path", {
  className: "cls-3",
  d: "M122.22 182.72l9 17.31a11.24 11.24 0 01-.19 9.2 15.15 15.15 0 01-2.36 3.67 18 18 0 01-4.63 3.8c-9.12 5.33-17.55 10.27-19.45-1.27a15 15 0 01.33-6.33c.24-.87.48-1.71.73-2.48a10 10 0 00-1-8.17l-2.2-3.69z"
}), React.createElement("g", {
  clipPath: "url(#clip-path-4)"
}, React.createElement("circle", {
  className: "cls-19",
  cx: 104.77,
  cy: 206.19,
  r: 5.64,
  transform: "rotate(-30.05 104.76 206.17)"
}), React.createElement("path", {
  className: "cls-19",
  d: "M137.86 193.56l-8.31 2.72a11.24 11.24 0 01-.19 9.2 15.15 15.15 0 01-2.36 3.67 18 18 0 01-4.63 3.8c-9.12 5.33-17.55 10.27-19.45-1.27a15 15 0 01.33-6.33c.24-.87.48-1.71.73-2.48.87-2.73-7.64 14.37-9.11 11.91l5.55 11.39 10.19 1.4 12.68-4.21 9.87-7.27 3.89-5.9 1.42-6.56-.53-5.43z"
})), React.createElement("rect", {
  className: "cls-15",
  x: 97.79,
  y: 184.92,
  width: 26.62,
  height: 4.96,
  rx: 2.48,
  ry: 2.48,
  transform: "rotate(-30.05 111.1 187.4)"
}), React.createElement("path", {
  className: "cls-20",
  transform: "rotate(149.95 121.65 194.6)",
  d: "M121.1 189.63h1.11v9.93h-1.11z"
}), React.createElement("path", {
  className: "cls-20",
  transform: "rotate(149.95 116.67 197.48)",
  d: "M116.11 192.52h1.11v9.93h-1.11z"
}), React.createElement("path", {
  className: "cls-20",
  transform: "matrix(-.87 .5 -.5 -.87 320.47 306.06)",
  d: "M118.61 191.07h1.11V201h-1.11z"
}), React.createElement("path", {
  className: "cls-4",
  transform: "rotate(149.95 2.72 62.75)",
  d: "M-.21 62.39h5.87v.72H-.21z"
}), React.createElement("path", {
  id: "ear-3",
  "data-name": "ear",
  className: "cls-4",
  d: "M11.68 50.55v18.26a7.3 7.3 0 01-7.3-7.3v-3.65a7.3 7.3 0 017.3-7.3z",
  transform: "rotate(-29.9 8.12 59.79)"
}), React.createElement("g", {
  clipPath: "url(#clip-path-5)"
}, React.createElement("ellipse", {
  id: "circle",
  className: "cls-23",
  cx: 34.63,
  cy: 43.98,
  rx: 29.49,
  ry: 31.36,
  transform: "rotate(-18.18 34.63 43.97)"
}), React.createElement("ellipse", {
  className: "cls-23",
  cx: 4.89,
  cy: 61.55,
  rx: 0.9,
  ry: 1.8,
  transform: "rotate(-30.05 4.89 61.54)"
})), React.createElement("path", {
  className: "cls-4",
  transform: "rotate(-30.05 84.4 15.49)",
  d: "M81.49 15.13h5.87v.72h-5.87z"
}), React.createElement("path", {
  id: "ear-4",
  "data-name": "ear",
  className: "cls-4",
  d: "M82.77 9.43v18.26a7.3 7.3 0 01-7.3-7.3v-3.66a7.3 7.3 0 017.3-7.3z",
  transform: "rotate(149.95 79.11 18.56)"
}), React.createElement("g", {
  clipPath: "url(#clip-path-6)"
}, React.createElement("ellipse", {
  id: "circle-2",
  "data-name": "circle",
  className: "cls-23",
  cx: 52.87,
  cy: 34.43,
  rx: 29.25,
  ry: 31.04,
  transform: "rotate(-30.05 52.87 34.42)"
}), React.createElement("ellipse", {
  className: "cls-23",
  cx: 82.25,
  cy: 16.69,
  rx: 0.9,
  ry: 1.8,
  transform: "rotate(-30.05 82.25 16.69)"
})), React.createElement("circle", {
  id: "_Ellipse_2",
  "data-name": "<Ellipse>",
  className: "cls-5",
  cx: 43.68,
  cy: 39.58,
  r: 38.78,
  transform: "rotate(-29.9 43.81 39.6)"
}), React.createElement("g", {
  clipPath: "url(#clip-path-7)"
}, React.createElement("ellipse", {
  id: "_Ellipse_3",
  "data-name": "<Ellipse>",
  className: "cls-1",
  cx: 45.72,
  cy: 38.4,
  rx: 36.63,
  ry: 38.78,
  transform: "rotate(-29.9 45.85 38.4)"
}), React.createElement("ellipse", {
  id: "_Ellipse_4",
  "data-name": "<Ellipse>",
  cx: 45.71,
  cy: 38.24,
  rx: 36.55,
  ry: 38.78,
  transform: "rotate(-30.05 45.71 38.23)",
  fill: "#fff"
}), React.createElement("ellipse", {
  id: "_Ellipse_5",
  "data-name": "<Ellipse>",
  className: "cls-1",
  cx: 44.35,
  cy: 39.03,
  rx: 34.97,
  ry: 38.78,
  transform: "rotate(-30.05 44.34 39.02)"
})), React.createElement("path", {
  id: "purple",
  d: "M68 25.49c7.78 13.45 3.6 29.1-9.85 36.88s-31.05 4.75-38.83-8.7-1.63-30.24 11.82-38S60.25 12 68 25.49z",
  fill: "#7f1bbf"
}), React.createElement("path", {
  id: "purple-2",
  "data-name": "purple",
  d: "M67.61 24.72c7.53 13 4.26 27.7-7.7 34.62a26.11 26.11 0 01-26.15-45.2c11.96-6.92 26.32-2.43 33.85 10.58z",
  fill: "url(#linear-gradient-4)"
}), React.createElement("path", {
  className: "cls-29",
  d: "M45.16 11.75c9.13 0 17.72 4.84 22.87 13.74 7.78 13.45 3.6 29.1-9.85 36.88a31.21 31.21 0 01-15.59 4.22c-9.34 0-18.31-4.34-23.27-12.92-7.78-13.45-1.63-30.24 11.82-38a27.93 27.93 0 0114-3.89m0-5a33.11 33.11 0 00-16.51 4.57C12.29 20.78 6.16 40.9 15 56.17c5.58 9.65 15.9 15.42 27.6 15.42a36.19 36.19 0 0018.08-4.89A32 32 0 0075.9 47.35 32 32 0 0072.36 23c-5.88-10.17-16-16.24-27.2-16.24z",
  id: "outline"
}), React.createElement("path", {
  className: "cls-4",
  d: "M40.09 66.57h44.2A7.68 7.68 0 0192 74.25V76H32.41v-1.75a7.68 7.68 0 017.68-7.68z",
  transform: "rotate(-30.05 62.18 71.3)"
}), React.createElement("path", {
  className: "cls-29",
  d: "M35.38 65.4h52.27a3.65 3.65 0 013.64 3.6v5.83H31.73V69a3.65 3.65 0 013.65-3.6z",
  transform: "rotate(-30.05 61.51 70.13)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 40.69,
  cy: 82.44,
  r: 2.26,
  transform: "rotate(-30.05 40.68 82.43)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 47.66,
  cy: 78.41,
  r: 2.26,
  transform: "rotate(-30.05 47.65 78.41)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 54.62,
  cy: 74.38,
  r: 2.26,
  transform: "rotate(-30.05 54.62 74.37)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 61.59,
  cy: 70.35,
  r: 2.26,
  transform: "rotate(-30.05 61.58 70.35)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 68.55,
  cy: 66.32,
  r: 2.26,
  transform: "rotate(-30.05 68.55 66.33)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 75.52,
  cy: 62.29,
  r: 2.26,
  transform: "rotate(-30.05 75.52 62.29)"
}), React.createElement("circle", {
  className: "cls-7",
  cx: 82.48,
  cy: 58.26,
  r: 2.26,
  transform: "rotate(-30.05 82.47 58.26)"
})));

var SvgAstronaut = function SvgAstronaut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 177.65 227.57",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _ref3));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAstronaut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/astronaut.ccb8a063.svg";
export { ForwardRef as ReactComponent };